














































import Vue from 'vue';
import Component from 'vue-class-component';
import TimelineItemForm from '@/components/Challenges/tabs/timeline/TimelineItemForm.vue';
import {Prop, Watch} from 'vue-property-decorator';
import {TimelineInteractionModel, TimelineModel} from '@/models/timeline.model';
import DeleteButton from '@/components/Shared/buttons/DeleteButton.vue';
import SendButton from '@/components/Shared/buttons/SendButton.vue';
import OpenFileButton from '@/components/Shared/buttons/OpenFileButton.vue';
import TimeLineFile from '@/components/Challenges/tabs/timeline/TimeLineFile.vue';
import {challengeModule, timelineState} from '@/utils/store-acessor';
import {validators} from '@/utils/validations';
import {ChallengeModel} from '@/models/challenge.model';
import moment from 'moment';

@Component({
  components: {TimeLineFile, OpenFileButton, SendButton, DeleteButton, TimelineItemForm}
})
export default class TimelineContestantInteraction extends Vue {
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @Prop({required: true}) timeline!: TimelineModel;
  model = new TimelineInteractionModel();
  rules = validators;
  loading = false;
  destroyLoader = false;
  snackbarVisibility = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarMessage: string = '';

  get hasReplies(): boolean {
    return (
            !!this.timeline.interaction
            && !!this.timeline.interaction.replies
            && this.timeline.interaction.replies.length > 0
    );
  }

  async onSend() {
    this.snackbarVisibility = false;
    if (this.timeline.id && this.challenge?.id) {
      try {
        this.loading = true;
        if (!this.model.id) {
          await timelineState.createInteraction({
            challengeId: this.challenge.id,
            timelineId: this.timeline.id,
            payload: this.model
          })
        } else {
          await timelineState.updateInteraction({
            challengeId: this.challenge.id,
            interactionId: this.model.id,
            timelineId: this.timeline.id,
            payload: this.model,
          })
        }
        this.successToSendInteraction();
      } catch (e) {
        this.failedToSendInteraction();
      } finally {
        this.loading = false;
      }
    }
  }

  async onDelete() {
    this.snackbarVisibility = false;
    if (this.model?.id && this.timeline?.id && this.challenge?.id) {
      this.destroyLoader = true;
      try {
        await timelineState.deleteInteraction({
          interactionId: this.model.id,
          challengeId: this.challenge.id,
          timelineId: this.timeline.id
        });
        this.onToastMessage('timeline.messages.interaction_deleted', 'green')
      } catch (e) {
        this.onToastMessage('timeline.messages.interaction_deleted_error', 'red')
      } finally {
        this.destroyLoader = false;
      }
    }
  }


  failedToSendInteraction() {
    this.onToastMessage('timeline.messages.interaction_registered_error', 'red')
  }

  successToSendInteraction() {
    this.onToastMessage('timeline.messages.interaction_registered', 'green')
  }

  @Watch('timeline', {immediate: true, deep: true})
  onTimelineChange(value: TimelineModel) {
    if (value.interaction) {
      this.model = {...value.interaction}
    } else {
      this.model = new TimelineInteractionModel();
    }
  }

  isActive(): boolean {
    const start = moment(this.timeline.start_at);
    const finish = moment(this.timeline.finish_at);
    const current = moment(new Date());
    if (!!this.timeline.finish_at) {
      return start.isSameOrBefore(current) && finish.isSameOrAfter(current);
    } else {
      return start.isSameOrBefore(current)
    }
  }

  private onToastMessage(message: string, color: 'green' | 'red') {
    this.snackbarColor = color;
    this.snackbarVisibility = true;
    this.snackbarMessage = message;
  }
}
